import { ReactNode, useState } from 'react';

export interface Passo {
  titulo: string;
  node: ReactNode;
  validar?: () => string | null | undefined | Promise<string | null | undefined>;
}

export default function Passos({ passos, rotuloFim }: { passos: Passo[]; rotuloFim?: string }) {
  const [i, setI] = useState(0);
  const [erro, setErro] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const idx = Math.min(i, passos.length - 1);
  const ultima = idx === passos.length - 1;

  async function irPara(k: number) {
    if (k === idx) return;
    if (k < idx) {
      setErro('');
      setI(k);
      return;
    }

    const validar = passos[idx].validar;
    if (validar) {
      setOcupado(true);
      try {
        const msg = await validar();
        if (msg) {
          setErro(msg);
          return;
        }
      } catch (e) {
        setErro(e instanceof Error ? e.message : String(e));
        return;
      } finally {
        setOcupado(false);
      }
    }
    setErro('');
    setI(k);
  }

  return (
    <div className="wz">
      <div className="wz-steps">
        {passos.map((p, k) => (
          <button
            key={k}
            type="button"
            className={'wz-step' + (k === idx ? ' on' : '') + (k < idx ? ' done' : '')}
            disabled={ocupado}
            onClick={() => irPara(k)}
          >
            <span>{k < idx ? '✓' : k + 1}</span>
            <b>{p.titulo}</b>
          </button>
        ))}
      </div>

      <div className="wz-body">{passos[idx].node}</div>

      {erro && <div className="msg-erro" style={{ marginTop: 10 }}>{erro}</div>}

      <div className="wz-nav">
        <button type="button" className="btn sec" disabled={idx === 0 || ocupado} onClick={() => irPara(idx - 1)}>← Voltar</button>
        {!ultima
          ? <button type="button" className="btn" disabled={ocupado} onClick={() => irPara(idx + 1)}>{ocupado ? 'Verificando...' : 'Próximo →'}</button>
          : <span className="wz-fim">{rotuloFim || 'Última etapa'}</span>}
      </div>
    </div>
  );
}
